import { Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { Link } from 'react-router';

import MoreIcon from '@asset/more.icon.svg?react';
import { PaymentHistoryInterface } from '@interface/billing/billing.interface';

export const paymentHistoryOptions: ColumnsType<PaymentHistoryInterface> = [
  {
    title: 'Billing period',
    dataIndex: 'periodEnd',
    key: 'periodEnd',
    render: (periodEnd) => dayjs(periodEnd * 1000).format('DD/MM/YYYY'),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status) => <Tag color='green'>{status}</Tag>,
  },
  {
    title: 'Items',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Transactions',
    dataIndex: 'created',
    key: 'created',
    render: (created) => dayjs(created * 1000).format('DD/MM/YYYY HH:MM'),
  },
  {
    title: 'Total',
    dataIndex: 'paid',
    key: 'paid',
    render: (paid) => `€ ${(paid * (1 / 100)).toFixed(2)}`,
  },
  {
    dataIndex: 'url',
    key: 'url',
    render: (url) => (
      <Link target='_blank' to={url}>
        <MoreIcon />
      </Link>
    ),
  },
];
